export default "__VITE_ASSET__W$7A_o5b__"